import React from 'react'
import ReactDOM from 'react-dom'
import './assets/style.scss'
import { LoadingProvider } from './contexts/loading'
import App from './app'

ReactDOM.render(<LoadingProvider><App /></LoadingProvider>, document.getElementById('root'))
